module.exports = __webpack_public_path__ + "img/1a.85549986.png";